import {getEstimatedValue, getEstimatedValueForDate, getMonthsBetween, weeksBetween} from "../../utils";
import {getRegRemainingInterest} from "../../financeUtils";


export function getDepValues(vehicle, start_date, term){
  // get depreciated value after term
  const today = new Date();
  const term_start_date = new Date(start_date)
  const term_end_date = new Date(new Date().setDate(term_start_date.getDate() + term * 7))

  const finance = getRelevantFinanceAgreement(vehicle.finance_agreements);
  if (!finance) {
    return null
  }

  const startValue = getEstimatedValueForDate(finance, term_start_date)
  const endValue = getEstimatedValueForDate(finance, term_end_date)
  return [startValue, endValue, finance]
}
export function getShortTermRate(rental, days) {
  if (!rental || !rental.rate_card || !rental.rate_card.id) {
    return 0
  }

  const rateCard = rental.rate_card

  let rate = 0

  for (let i = 1; i <= days; i++) {
    if (i < 2) {
      rate = rate + rateCard.day1_rate
    }
    if (1 < i && i < 6) {
      rate = rate + rateCard.day2_5_rate
    }
    if (5 < i && i < 28) {
      rate = rate + rateCard.day6_27_rate
    }
    if (i > 27) {
      rate = rate + rateCard.day_28_plus_rate
    }
  }

  return rate

}

export function getSuggestedRate(vehicle, mileage, start_date, term, margin, additional) {
  if (!vehicle || !vehicle.make || !start_date || !margin || term <= 0) {
    return null
  }
  // This variable controls how fast the multiplier goes up
  let basePerc = 9;
  // the price at term 13 was ok (just) and could not go any higher so we do not include it in this range
  if (term <= 52 && term > 13){
    basePerc = 13;
  }
  // if they are taking it for 2 or more years we do not want to increase the price at all
  if (term >= 104){
    basePerc = 0
  }
  // do some maths to inflate the price of the vehicle based on how long they are taking it
  let percentMulti = 1 + ((Math.max((104/term), 1) * basePerc) / 100);


  const maintenanceCostMile = vehicle.make.maintenance_cost_per_mile + vehicle.make.additional_depreciation_per_mile
  const maintenanceCostTerm = maintenanceCostMile * (mileage / 52) * term

  const maintenanceCostWeekly = maintenanceCostTerm / term

  // get depreciated value after term
  const today = new Date();
  const term_start_date = new Date(start_date)
  const term_end_date = new Date(new Date().setDate(term_start_date.getDate() + term * 7))

  const finance = getRelevantFinanceAgreement(vehicle.finance_agreements, today);
  if (!(!!finance)){
      return 0
  }
  let totalInterest = 0;
  let weeklyInterest = 0
  if(finance.finance_type === "STOCKING_PLAN"){
    // get months between interest repayment start and end
    let start = new Date(finance.sp_interest_repayment_start_date);
    let end = new Date(finance.sp_interest_repayment_end_date);
    let months = getMonthsBetween(start, end);

    totalInterest = finance.sp_monthly_interest_charge * months
    const agreementWeeks = weeksBetween(finance.sp_interest_repayment_start_date, finance.sp_interest_repayment_end_date);
    weeklyInterest = (totalInterest / agreementWeeks)
  }
  else if(finance.finance_type === "LEASE_AGREEMENT" || finance.finance_type === "REGULAR"){
    totalInterest = finance.payment_term * finance.monthly_payment - finance.finance_amount_borrowed
    const agreementWeeks = weeksBetween(finance.finance_start_date, finance.end_date)
    weeklyInterest = (totalInterest / agreementWeeks)
  }
  else if(finance.finance_type === "HIRE_AGREEMENT"){
    // Same calculations but should not include dep value per mile
    const maintenanceCostMile = vehicle.make.maintenance_cost_per_mile
    const maintenanceCostTerm = maintenanceCostMile * (mileage / 52) * term

    const maintenanceCostWeekly = maintenanceCostTerm / term
    let weeklyRate = finance.daily_rate * 7;
    weeklyRate = weeklyRate * (1 + margin.margin / 100);

    // get fixed costs (fire extinguisher etc)
    const fixedCosts = vehicle.type.fixed_hire_costs
    const additionalCosts = additional
    const weeklyFixedCosts = (fixedCosts + additionalCosts * 1) / term

    let totalCost = (weeklyRate + weeklyFixedCosts + maintenanceCostWeekly);
    let dailyCost = Math.round((totalCost / 7) * 100) / 100
    dailyCost = dailyCost * percentMulti;
    // We need to return
    return dailyCost;
  }

  // if the finance_agreement is not one of the above then 0 interest should be counted for

  const startValue = getEstimatedValueForDate(finance, term_start_date)
  const endValue = getEstimatedValueForDate(finance, term_end_date)
  // get loss of value over term, averaged weekly
  const weeklyValueLoss = (startValue - endValue) / term


  // get fixed costs (fire extinguisher etc)
  const fixedCosts = vehicle.type.fixed_hire_costs
  const additionalCosts = additional
  const weeklyFixedCosts = (fixedCosts + additionalCosts * 1) / term

  //const totalWeeklyCost = weeklyFixedCosts + weeklyInterest + weeklyValueLoss + maintenanceCostWeekly
  const totalWeeklyCost = ((weeklyInterest + weeklyValueLoss) * (1 + margin.margin / 100)) + weeklyFixedCosts + maintenanceCostWeekly

  let totalDailyCost = Math.round((totalWeeklyCost / 7) * 100) / 100
  //totalDailyCost = totalDailyCost * percentMulti
  return totalDailyCost // PROFIT MARGIN should not be applied here? fixed costs and maintenance should not have profit margin applied?

}

function getRelevantFinanceAgreement(agreements, today) {
  // Filter out agreements with an early_settlement_date
  if(!(!!agreements)){
    return {};
  }
  const filterActiveAgreements = (agreement, today) => {
    if(agreement.end_date){
      let end_date = new Date(agreement.end_date);
      if(end_date > today){
        return true;
      }
      else{
        return false;
      }
    }
    // If there is not an end date then it is just a purchase agreement
    return true;
  }
  let filteredAgreements = agreements.filter(agreement => !agreement.early_settlement_date)//.filter(agreement => agreement.finance_type == 'LEASE_AGREEMENT' || agreement.finance_type == 'REGULAR');
  // Filter for only active finance agreements or finance agreements that are of type None/hire
  // When a finance agreement ends, as long as it is not settled then the agreement is still valid
  //filteredAgreements = filteredAgreements.filter(agreement => filterActiveAgreements(agreement, today))
  // Check if there are any agreements left after filtering
  if (filteredAgreements.length === 0) {
    return null; // or you can return an empty object or throw an error, depending on your needs
  }
  // Find the latest agreement based on the end_date
  const latestAgreement = filteredAgreements.reduce((latest, current) => {
    return new Date(current.end_date) > new Date(latest.end_date) ? current : latest;
  });

  return latestAgreement;
}
